@for (equipment of equipmentList; track equipment) {
  <div class="pad-vertical-20">
    <h3 class="pad-left-10">{{ equipment.equipmentName }}</h3>
    <ds-equipment-selection-item
      [optionItem]="equipment"
      [form]="form"
      (optionChangeEvent)="optionUpdated($event)"
    ></ds-equipment-selection-item>
    <p class="caption pad-left-10">{{ equipment.caption }}</p>
  </div>
}

@if (categoryform) {
  <div class="pad-vertical-20">
    <h3 class="pad-left-10">{{ antiTheftName }}*</h3>
    <h3 class="pad-left-10">{{ newVehicleFeatureAntiTheftText }}</h3>
    <ds-category-selection-list
      [form]="categoryform"
      [state]="state"
      (checklistUpdateEvent)="handleCheckBoxCategoryInteraction($event)"
    >
    </ds-category-selection-list>
    <p class="caption pad-left-10">{{ antiTheftCaption }}</p>
  </div>
}

@if (!!equipmentChecklist?.length) {
  <fieldset class="pad-top-20" data-cy="equipmentChecklistFieldset">
    <h3 class="pad-left-10">Other Equipment</h3>
    @for (equipment of equipmentChecklist; track equipment) {
      <div class="pad-vertical-20">
        <ds-equipment-checklist
          [equipment]="equipment"
          [form]="form"
          [optionCtrl]="form.controls[equipment.optionKey]"
          (equipmentSelectEvent)="checklistUpdated($event)"
        ></ds-equipment-checklist>
      </div>
    }
  </fieldset>
}
